import React from 'react'
import Form from '../../../form'
import ThumbUpIcon from '../../../../images/stories/thumbs-up.svg'
import Quote from '../../../quote'

export const MaxDance: React.FC = () => {
  return (
    <>
      <div className='onlinepbx__container'>
        <div className='onlinepbx__story'>
          <div className='onlinepbx__story__block__row onlinepbx__story__block__row__head onlinepbx__story__block__row__bottom'>
            <div className='onlinepbx__story__left onlinepbx__story__description'>
              <h2>Автоматизируйте работу администратора и&nbsp;получайте на&nbsp;30% лидов больше</h2>
              <div className='onlinepbx__story__text onlinepbx__story__text__head'>
                Школа танцев MaxDance рассказали о&nbsp;четырёх критических ошибках, из-за которых они теряли клиентов,
                и&nbsp;с&nbsp;помощью каких инструментов получилось их&nbsp;исправить
              </div>
              <div>
                <Form text='Попробовать onlinepbx' pageName='Истории' />
              </div>
            </div>
            <div className='onlinepbx__story__right onlinepbx__story__image'>
              <img src={process.env.PUBLIC_DIR + '/images/stories/story1-big.png'} />
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story__block1'>
            <div>
              <h2 className='onlinepbx__content__header__center'>1. Пропускали вызовы в&nbsp;нерабочее время</h2>
              <div className='onlinepbx__story__block__center onlinepbx__story__block__quote'>
                <Quote width='922'>
                    <div>Новые клиенты чаще всего обращаются в студию по телефону — так быстрее всего получить актуальную информацию или записаться на занятие. У администраторов фиксированный график работы: с 8 утра до 22. Тут мы столкнулись с ошибкой номер один: клиенты часто звонят до начала и после окончания рабочего дня и их звонки нигде не фиксируются.</div>
                </Quote>
              </div>
            </div>
            <div className='onlinepbx__story__block__row onlinepbx__story__block__row__start'>
              <div className='onlinepbx__story__left onlinepbx__story__image'>
                <img src={process.env.PUBLIC_DIR + '/images/stories/story1-block1.svg'} />
              </div>
              <div>
                <div className='onlinepbx__story__block__header'>Как решили проблему</div>
                <div className='onlinepbx__story__text'>
                  <div className='onlinepbx__story__text__paragraph'>
                    Подключили телефонию onlinePBX, интегрировали с&nbsp;нашей CRM и&nbsp;стали автоматически
                    фиксировать все пропущенные звонки.
                  </div>
                  <div className='onlinepbx__story__text__paragraph'>
                    Записали голосовые приветствия, которые меняются в&nbsp;зависимости от&nbsp;времени суток и&nbsp;дня
                    недели.
                  </div>
                  <div className='onlinepbx__story__text__paragraph'>
                    Настроили переадресацию вызовов на&nbsp;телефон директора, если вызов никто не&nbsp;принял.
                  </div>
                </div>
                <div className='onlinepbx__story__block__thumb'>
                  <img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-up.svg'} className='onlinepbx__story__block__thumb__icon' />
                  <div className='onlinepbx__story__text__medium'>
                    Администратор начал перезванивать по&nbsp;всем пропущененным, поэтому их&nbsp;количество снизилось
                    с&nbsp;30% до&nbsp;5%
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story__block2'>
            <h2 className='onlinepbx__content__header__center'>2. Не&nbsp;могли прослушать совершённый звонок</h2>
            <div className='onlinepbx__story__block__center onlinepbx__story__block__quote'>
              <Quote width='922'>
                <div>Вторая ошибка: из-за того, что не было возможности послушать, как администраторы общаются с клиентами и посмотреть сколько в день обрабатывают звонков — мы не могли отследить эффективность и загруженность сотрудников.</div>
              </Quote>
            </div>
            <div className='onlinepbx__story__block__header onlinepbx__story__block__header__center onlinepbx__story__block__header__padding'>
              Как решили проблему
            </div>
            <div className='onlinepbx__story__text onlinepbx__story__text__center'>
              В&nbsp;панели управления onlinePBX записываются входящие и&nbsp;исходящие звонки, их&nbsp;можно
              прослушивать в&nbsp;любой момент и&nbsp;с&nbsp;любого устройства, где есть интернет и&nbsp;возможность
              зайти в&nbsp;свою учетную запись.
            </div>
            <div>
              <img src={process.env.PUBLIC_DIR + '/images/stories/story1-block2.svg'} />
            </div>
            <div className='onlinepbx__story__block__thumb'>
              <ThumbUpIcon className='onlinepbx__story__block__thumb__icon onlinepbx__story__block__thumb__icon__margin' />
              <div className='onlinepbx__story__text__medium'>
                Добавили новые скрипты для общения с&nbsp;клиентами, благодаря чему увеличился средний чек.
              </div>
            </div>
          </div>

          <div className='onlinepbx__story__block'>
            <div>
              <h2 className='onlinepbx__content__header__center'>
                {`3. Нет информации по загруженности\n менеджеров и администраторов`}
              </h2>
              <div className='onlinepbx__story__block__center onlinepbx__story__block__quote'>
                <Quote width='708'>
                  <div>Третья ошибка: мы не могли анализировать статистику звонков для каждого сотрудника</div>
                </Quote>
              </div>
            </div>
            <div className='onlinepbx__story__block__row onlinepbx__story__block__row__center'>
              <div className='onlinepbx__story__left onlinepbx__story__description'>
                <div className='onlinepbx__story__block__header'>Как решили проблему</div>
                <div className='onlinepbx__story__text'>
                  В&nbsp;панели управления onlinePBX настроен автоматический сбор статистики по&nbsp;работе
                  со&nbsp;звонками для всех сотрудников. И&nbsp;раз в&nbsp;неделю на&nbsp;e-mail приходит общая
                  статистика по&nbsp;вызовам.
                </div>
                <div className='onlinepbx__story__block__thumb'>
                  <img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-up.svg'} className='onlinepbx__story__block__thumb__icon' />
                  <div className='onlinepbx__story__text__medium'>
                    Равномерно распределяем нагрузку на&nbsp;администраторов с&nbsp;учётом их&nbsp;графиков работы
                    и&nbsp;снизили простои в&nbsp;работе сотрудников.
                  </div>
                </div>
              </div>
              <div className='onlinepbx__story__right onlinepbx__story__image'>
                <img src={process.env.PUBLIC_DIR + '/images/stories/story1-block3.svg'} />
              </div>
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story__block4'>
            <div>
              <h2 className='onlinepbx__content__header__center'>
                {`4. Неравномерное распределение\n звонков между школами`}
              </h2>
              <div className='onlinepbx__story__block__center onlinepbx__story__block__quote'>
                <Quote width='922'>
                  <div>Четвёртый фактор, который сильно влиял на количество заявок — неравномерное распределение звонков между школами, у которых были разные номера телефонов.</div>
                </Quote>
              </div>
            </div>
            <div className='onlinepbx__story__block__row onlinepbx__story__block__row__start'>
              <div className='onlinepbx__story__left onlinepbx__story__image'>
                <img src={process.env.PUBLIC_DIR + '/images/stories/story1-block4.svg'} />
              </div>
              <div className='onlinepbx__story__right onlinepbx__story__description'>
                <div className='onlinepbx__story__block__header'>Как решили проблему</div>
                <div className='onlinepbx__story__text'>
                  Купили номер в&nbsp;Voximplant и&nbsp;назначили его для двух школ&nbsp;&mdash; удобно для рекламы
                  и&nbsp;клиентов. Настроили логику входящих звонков по&nbsp;времени и&nbsp;дню недели. Для этого
                  воспользовались инструментами: умный перевод звонков, правило по&nbsp;времени и&nbsp;голосовое
                  приветствие с&nbsp;тоновым набором.
                </div>
                <div className='onlinepbx__story__block__thumb'>
                  <img src={process.env.PUBLIC_DIR + '/images/stories/thumbs-up.svg'} className='onlinepbx__story__block__thumb__icon' />
                  <div className='onlinepbx__story__text__medium'>
                    Устанавливаем и&nbsp;контролируем планы продаж администраторов. И&nbsp;ещё обнаружили полезный
                    бонус: автоматическое информирование клиентов о&nbsp;дне недели при звонке, позволяет избежать
                    ошибок при записи
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='onlinepbx__story__block onlinepbx__story__block6 onlinepbx__story__text__medium__width onlinepbx__story__text__medium onlinepbx__story__text__center'>
            <div className='onlinepbx__story__text__paragraph'>
              Если ранее было около&nbsp;30% пропущенных, то&nbsp;сейчас этот показатель уменьшился до&nbsp;5%,
              соответственно и&nbsp;выручка компании увеличилась.
            </div>
            <div className='onlinepbx__story__text__paragraph'>
              Количество клиентов студии выросло, у&nbsp;нас появилось больше направлений и&nbsp;удалось увеличить
              средний чек и&nbsp;выручку на&nbsp;15%.
            </div>
          </div>
        </div>
      </div>

      <div className='onlinepbx__story__block__form__wrapper'>
        <h2 className='onlinepbx__content__header__center'>
          Настроим сервис <span className='onlinepbx__content__header__green'>бесплатно</span> за 30 минут!
        </h2>
        <div className='onlinepbx__story__block__form'>
          <Form free isWhite text='Подключить бесплатно' pageName='Истории' />
        </div>
      </div>
    </>
  )
}

export default MaxDance
